import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import { cpfOrCnpjMask } from "~hooks/useHelpers";
import "../../../SearchList/styles.scss";
import useFormList from "../hooks/useFormList";
const FormList = ({ items, clickProposta }) => {
  const { renderTagContent, montaEndereco } = useFormList();

  return (
    <>
      <div className="wallet-search-list">
        <div className="container content">
          <div className="container flex items-center justify-between my-4"></div>
          {Array.isArray(items)
            ? items.map((item, index) => (
                <div key={index} className="card-item list" onClick={() => clickProposta(item)}>
                  <div className="flex gap-x-2 class flags">
                    <div className={"card-tag" + (item.tag === "Prospect" ? " !bg-secundaria" : "")}>
                      {renderTagContent(item)}
                    </div>
                    {item.bloqueado === true && <div className="card-tag card-tag-bloq">Bloqueado</div>}
                  </div>

                  <div className="card-content">
                    <h3 className="card-title">
                      {item?.codigo || item?.codigoProspect || ""} - {item.razaoSocial ?? item.nomeFantasia}
                    </h3>

                    <div className="card-description">
                      <p>
                        CPF/CNPJ: <b className="bold">{cpfOrCnpjMask(item.documento)}</b>
                      </p>
                      <p>
                        Segmento Desc.: <b className="bold">{item?.segmento?.nome ?? "Sem Segmento"}</b>
                      </p>
                      <p>
                        Grupo Centralizador:{" "}
                        <b className="bold">{item.grupoCentralizador || "Sem Grupo Centralizador"}</b>
                      </p>
                      <p>
                        Endereço: <b className="bold">{montaEndereco(item.endereco)}</b>
                      </p>
                    </div>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </>
  );
};

export default FormList;
